import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircleIcon, XCircleIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import LoadingSpinner from '../../Common/LoadingSpinner';

const PublicMembershipPaymentCallback = () => {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const status = searchParams.get('paycorp');
  const reqid = searchParams.get('reqid');
  const code = searchParams.get('code');
  
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    // We can add a verification step here if needed, 
    // but for now we just show the status returned by the gateway redirect
    const timer = setTimeout(() => {
      setVerifying(false);
    }, 1500);
    
    return () => clearTimeout(timer);
  }, []);

  if (verifying) return <LoadingSpinner message="Verifying your payment" />;

  const isSuccess = status === 'success';
  const isCancelled = status === 'cancelled';

  return (
    <div className="min-h-screen bg-[#f8fafc] flex items-center justify-center p-4 font-sans">
      <div className="max-w-md w-full bg-white rounded-xl shadow-xl shadow-gray-200/50 border border-gray-100 p-8 text-center">
        {isSuccess ? (
          <>
            <div className="w-20 h-20 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircleIcon className="w-12 h-12 text-emerald-500" />
            </div>
            <h2 className="text-2xl font-medium text-gray-900 mb-2">Thank You!</h2>
            <p className="text-sm text-gray-600 mb-6 leading-relaxed">
              Your payment has been processed successfully. Your membership status will be updated shortly. 
              A confirmation receipt has been sent to your email.
            </p>
            {reqid && (
              <div className="bg-gray-50 rounded-xl p-4">
                <p className="text-xs text-gray-400 font-medium mb-1">Transaction ID</p>
                <p className="text-sm tabular-nums font-medium text-gray-700">{reqid}</p>
              </div>
            )}
          </>
        ) : isCancelled ? (
          <>
            <div className="w-20 h-20 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-6">
              <ArrowPathIcon className="w-12 h-12 text-amber-500" />
            </div>
            <h2 className="text-2xl font-medium text-gray-900 mb-2">Payment Cancelled</h2>
            <p className="text-sm text-gray-600 mb-8 leading-relaxed">
              The payment process was cancelled. No charges were made to your card.
            </p>
            <button
              onClick={() => navigate(`/membership/payment/${token}`)}
              className="w-full py-4 bg-amber-500 text-white rounded-xl font-medium text-sm hover:bg-amber-600 transition-all shadow-xl shadow-amber-100"
            >
              Try Again
            </button>
          </>
        ) : (
          <>
            <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
              <XCircleIcon className="w-12 h-12 text-red-500" />
            </div>
            <h2 className="text-2xl font-medium text-gray-900 mb-2">Payment Failed</h2>
            <p className="text-sm text-gray-600 mb-8 leading-relaxed">
              We couldn't process your payment. {code ? `Error code: ${code}` : 'Please check your card details and try again.'}
            </p>
            <button
              onClick={() => navigate(`/membership/payment/${token}`)}
              className="w-full py-4 bg-red-600 text-white rounded-xl font-medium text-sm hover:bg-red-700 transition-all shadow-xl shadow-red-100"
            >
              Try Again
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PublicMembershipPaymentCallback;
